import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import StripePaymentForm from '../StripePaymentForm/StripePaymentForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const StripeCheckout = ({ price, description, autoCheckTerms }) => {
  return (
    <Elements stripe={stripePromise}>
      <StripePaymentForm price={price} description={description} autoCheckTerms={autoCheckTerms} />
    </Elements>
  );
};

export default StripeCheckout;
